import { useCallback } from "react";
import { TrackingEventName } from "./events";

export const useTrackEvent = () => {
	return useCallback((name: TrackingEventName, properties?: Record<string, unknown>) => {
		window.analytics?.track(name, properties);
	}, []);
};
